import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";


export default function Footer() {

    return (
        <footer id={"footer"} className={"footer"}>
            <Flex className={"container"}>
                <Text marginY={8}>
                    {"\u00A9"} 2023 - 2026 Michigan Computer Graphics | Made by Derek Goh and Aidan Donley
                </Text>
            </Flex>
        </footer>
    );
}
